<template>
  <div>

    <vue-action-buttons :buttons="actionButtons" />

    <vue-order-details :order="order" :reference="$route.params.reference" />

    <br />
    <div class="row">
      <div class="col-xl-3 col-12">
        <label for="">Client <span class="text-danger">*</span> </label>

        <vue-select :options="customers" v-model="order.customer_reference" labelColumn="society"
          valueColumn="reference" />
      </div>

       <div class="col-xl-3 col-12">
        <label for="">Date de commande<span class="text-danger">*</span></label>
        <input type="date" v-model="order.date" class="form-control" />
      </div>

      <div class="col-xl-3 col-12">
        <label for=""> Bon Nº <span class="text-danger">*</span></label>
        <input type="text" v-model="order.passPermit" class="form-control" />
      </div>

 
    </div>
 <br>
    <div class="row">
      

      <div class="col-xl-12">
        <label for="">
          Remarque
        </label>
        <textarea v-model="order.remark" class="form-control"></textarea>
      </div>
    </div>
    
    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12">

      </div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="save(order)">
          <i class="bi bi-check-square-fill"></i> Enregistrer
        </button>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-12">
        (<span class="text-danger">*</span>) : Ce champ est obligatoire.
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      reference: this.$route.params.reference,
      accept: false,
      actionButtons: [
        {
          label: "Modifier les elements",
          class: "btn btn-outline-success",
          icon: "bi bi-check2-square",
          action: () => this.$userRole != 'Magasinier' ? this.$router.push({ name: 'orders-items-edit', params: { reference: this.reference } }) : '',
        },
      ]
    };
  },
  computed: {
    ...mapGetters("order", {

      order: "getOrder",
    }),
    ...mapGetters("customer", {
      customers: "getAll",
    }),
  },
  methods: {
    async save(data) {
      await this.$store.dispatch("order/update", data);
    },
    async refresh() {
      await this.$store.dispatch("customer/getAll");
      await this.$store.dispatch("order/show", this.$route.params.reference);
    },
 

  },
  async mounted() {
    await this.$store.dispatch("customer/getAll");
    await this.$store.dispatch("order/show", this.$route.params.reference);
  },

};
</script>
